<template>
  <div class="page page--voucher">
    <div class="page--voucher__heading">
      Scan QR Code OR download the app from the front screen to access these offers at any time by touching the QR Code from your Phone or Device
    </div>
    <a v-for="item in filteredVouchers" class="voucher-item" :href="item.link" v-bind:key="item.name">
      <img :src="item.image.url" alt="">
    </a>
  </div>
</template>
<script>
import {getCache, setCache} from "@/services/cache";
import * as consts from '@/consts';

export default {
  data() {
    return {
      vouchers: [],
    }
  },
  mounted() {
    const endpoint = `${consts.FUNCTION_API_ENDPOINT}/vouchers`;
    const cache = getCache('vouchers');
    if (cache !== null) {
      this.vouchers = cache.vouchers;
    }
    else {
      fetch(`${endpoint}`, {
        method: 'GET',
        headers: {
          'x-secret': 'chameleon-isb-mini-site'
        }
      }).then(res => res.json()).then(result => {
        this.vouchers = result;
        if (result.length) {
          setCache(`vouchers`, {
            vouchers: this.vouchers
          }, 2); // 2 minutes
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
  computed: {
    filteredVouchers() {
      return this.vouchers.filter((item) => {
        return item.image !== undefined && item.image.url;
      })
    }
  }
}
</script>
